<template>


  <t-page>

    <b-modal @hidden="getPage()" no-close-on-backdrop no-close-on-esc size="lg" v-model="modalTrigger"
             id="modal-type-status-trigger"
             hide-footer
             :title="'Gatilhos status operacional: ' + modalTriggerName">

      <t-form-list-trigger primary-key-column="operationStatusTriggerId"
                           foreign-key-column-trigger="operationStatusId"
                           path-trigger="production/type-status-trigger"
                           :foreign-key="modalTriggerOperationStatusTriggerId"
                           :type-trigger="TriggerEventType.typeList.STATUS"/>
    </b-modal>

    <t-page-list :title="t('list-of') + currentPage.pageTitle" :user-auth="userAuth"
                 :total-pages="request.totalPages" :total-elements="request.totalElements" @getPage="getPage" :breadcrumb="breadcrumb" title-items="Status Operacionais">


      <template #search>
        <t-button v-if="userAuth.validation.validationCreate" :text="t('insert') + ' ' + currentPage.singularTitle" :to="currentPage.name + '-form-new'"
                  primary/>
        <t-content-header-search-default @searchChange="searchDefault"
                                         @onClearSearch="clearSearch()"
                                         :filtered-default="filteredDefault" :filtered-advanced="filteredAdvanced"
                                         :search-form="form" />
      </template>

      <b-table hover :items="request.content" v-if="checkViewListTableDefault()" :busy="!pageListIsLoaded"
               :fields="fields">

        <template #cell(first)="{item}">
          <t-list-link-primary :label="item.name" :userAuth="userAuth" :id="item.operationStatusNumber"
                               :path="currentPage.path"/>

          <small v-if="item.note !== ''"><br />{{item.note}}</small>

        </template>

        <template #cell(color)="{item}">
          <div class="mb-2 mr-2 badge badge-dot badge-dot-xl" :style="{'background-color': item.color}"></div>
        </template>

        <template #cell(typeOperation)="{item}">

          <div class="mb-2 mr-2 badge badge-focus" v-if="item.typeOperation === 1">Comum</div>
          <div class="mb-2 mr-2 badge badge-success" v-else-if="item.typeOperation === 2">Finalização com sucesso
          </div>
          <div class="mb-2 mr-2 badge badge-danger" v-else-if="item.typeOperation === 3">Finalização com erro</div>

        </template>


        <template #cell(status)="{item}">
          {{ item.status | statusLabel }}
        </template>

        <template #cell(actions)="{item}">

          <div class="text-right">

            <t-button small @click="openModalTrigger(item.operationStatusId, item.name)" class="mr-2">
              <b-icon-bezier2></b-icon-bezier2>
              Gatilhos
              <div class="mr-1 badge badge-sm badge-pill bg-warning text-black-50" style="right: -3px; top:-7px;"
                   v-if="item.qtdTriggers > 0">{{ item.qtdTriggers }}
              </div>

            </t-button>

            <t-list-actions-default :form-path="currentPage.path" :id="item.operationStatusNumber"
                                    :userAuth="userAuth"/>

          </div>
        </template>

      </b-table>

      <t-msg v-else warning>{{ t('no-record-found') }}</t-msg>

    </t-page-list>

  </t-page>


</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageListMixin from "@/mixins/page/pageListMixin"
import TriggerEventType from "@/model/types/resource/TriggerEventType";
import tFormListTrigger from "@/components/template/form/list/t-form-list-trigger"

export default {
  mixins: [pageDefaultMixin, pageListMixin],
  components: {tFormListTrigger},
  name: 'TypeStatusProduction',
  data() {
    return {
      TriggerEventType,
      path: "", //Utilizar somente quando fora do padrão
      fields: [
        {key: "first", label: "Status Operacional"},
        {key: "color", label: "Cor"},
        {key: "typeOperation", label: "Tipo Operação"},
        {key: "status", label: "Status"},
        {key: "actions", label: ""},
      ],
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      modalCustomer: false,
      modalCustomerName: "",
      modalTriggerOperationStatusTriggerId: 0,

      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {

      this.breadcrumb = [
        {text: 'Configurações', to: {name: 'production-setting'}},
      ]

    },
    async mountedContinued() {


    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    openModalTrigger(id, name) {
      this.modalTrigger = true
      this.modalTriggerName = name
      this.modalTriggerOperationStatusTriggerId = id
    },

    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedList()

    await this.mountedContinued()

  },
}
</script>
